import { SalePointId } from '@/components/modules/Application/IberiaCards/_shared/types/SalePoint';
import { StandsAgent } from '@/components/modules/Application/IberiaCards/_shared/types/StandsAgent';

// MVP mapping of the stands agents, looked up by the logged-in user's email.
// Source: Listado_Agentes_IBC_E-MAIL.xlsx (Iberia Cards, 2026-09-23). Only profile AGENTE is
// included - the SUPERVISOR and the AGENTE VERIFICADOR rows (location MAD) are left out until their
// role in stands is defined.
//
// TODO: Stop shipping these emails in plain text in the bundle - hash them or move the lookup to a
// backend endpoint (see the Stands notes in Notion).
// TODO: Confirm with Iberia Cards that the raw code (e.g. '024') is what goes in cvd_ts and, if so,
// whether it keeps the leading zeros ('024') or not ('24').
export const STANDS_AGENTS: StandsAgent[] = [
  {
    email: 'jose.valverde@eurofirms.com',
    code: '001',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'veronica.oliva@eurofirms.com',
    code: '002',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'susana.guerrero@eurofirms.com',
    code: '003',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'carmen.sancha@eurofirms.com',
    code: '004',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'elena.gaina@eurofirms.com',
    code: '005',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'maria.garciah@eurofirms.com',
    code: '006',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'maria.campos@eurofirms.com',
    code: '007',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'hugo.garcia@eurofirms.com',
    code: '008',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'maria.martinez@eurofirms.com',
    code: '009',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'maria.gonzalezg@eurofirms.com',
    code: '010',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'herlis.soto@eurofirms.com',
    code: '011',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'lucia.elich@eurofirms.com',
    code: '012',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'ignacio.gonzalez@eurofirms.com',
    code: '013',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'estrella.gil@eurofirms.com',
    code: '014',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'mariadelpilar.romero@eurofirms.com',
    code: '015',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'ramon.gonzalez@eurofirms.com',
    code: '016',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'jose.santamaria@eurofirms.com',
    code: '017',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  {
    email: 'beatriz.marquezs@eurofirms.com',
    code: '018',
    salePointIds: [SalePointId.MT2, SalePointId.MT4, SalePointId.FER],
  },
  { email: 'maximiliano.garozzo@eurofirms.com', code: '019', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  { email: 'victor.roca@eurofirms.com', code: '020', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  { email: 'raphael.malonda@eurofirms.com', code: '021', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  { email: 'roberto.albajes@eurofirms.com', code: '022', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  { email: 'sergio.garfia@eurofirms.com', code: '023', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  { email: 'jose.belomnte@eurofirms.com', code: '024', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  { email: 'gloria.maita@eurofirms.com', code: '025', salePointIds: [SalePointId.BCN, SalePointId.FER] },
  // Test agents (dev, stg, prod), not part of the Iberia Cards list
  {
    email: 'iberiacards+dev.stands@nemuru.com',
    code: '999',
    salePointIds: [SalePointId.BCN, SalePointId.MT2, SalePointId.MT4, SalePointId.FER, SalePointId.SEV],
  },
  {
    email: 'iberiacards+stg.stands@nemuru.com',
    code: '999',
    salePointIds: [SalePointId.BCN, SalePointId.MT2, SalePointId.MT4, SalePointId.FER, SalePointId.SEV],
  },
  {
    email: 'iberiacards+prod.stands@nemuru.com',
    code: '999',
    salePointIds: [SalePointId.BCN, SalePointId.MT2, SalePointId.MT4, SalePointId.FER, SalePointId.SEV],
  },
];
